<template>
<div id="fact-check-app">
    <transition>
        <router-view></router-view>
    </transition>
</div>
</template>

<script>
export default {
    name: 'fc-base-componet',
}
</script>

<style lang="scss">

@import "../../../css/Tools/PlaceHolders.scss";

.uno-col .alpha{
    padding: 0px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.loading-spinner{
    animation: rotation 1s infinite linear;
}

.loading-container{
    display: flex;
    justify-content: center;
    align-content: center;
}

body.fact_check_review{
    .alpha{
        .polls-header{
            display: block;
            padding: 0 20px;
        }

        p[welcome-description]{
            padding: 0 20px;
        }

        #fact-check-app{
            padding: 0px 20px;
        }
    }
}
</style>